module.exports = __webpack_public_path__ + "static/img/图层34.ef680dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facilitator/图层34.png
// module id = yfLJ
// module chunks = 0